// Thin wrapper around `tz-lookup` so callers can derive an IANA timezone
// name from a coordinate pair. The library is heavy enough (~100KB) that we
// import it lazily - onboarding's home-course step and Settings are the
// only places that need it, neither of which is on the hot path.

let tzLookupPromise = null;

const loadTzLookup = () => {
  if (!tzLookupPromise) {
    tzLookupPromise = import('tz-lookup').then((m) => m.default || m);
  }
  return tzLookupPromise;
};

/**
 * Resolve a coordinate pair to an IANA timezone name (e.g. "Europe/London").
 * Returns null when lat/lng are missing or the lookup throws.
 *
 * @param {number|string|null|undefined} lat
 * @param {number|string|null|undefined} lng
 * @returns {Promise<string|null>}
 */
export const getTimezoneForCoordinates = async (lat, lng) => {
  const latNum = typeof lat === 'string' ? parseFloat(lat) : lat;
  const lngNum = typeof lng === 'string' ? parseFloat(lng) : lng;
  if (!Number.isFinite(latNum) || !Number.isFinite(lngNum)) return null;

  try {
    const tzLookup = await loadTzLookup();
    return tzLookup(latNum, lngNum);
  } catch {
    return null;
  }
};
